import { Link } from 'react-router-dom';
import { EmptyState, IconSearch, PageHeader } from '../components/ui';
import { HelpLink } from '../components/help';
import { t } from '../lib/i18n';

export function NotFoundPage(): JSX.Element {
  return (
    <>
      <PageHeader title={t('naoEncontrada.titulo')} />
      <div className="panel">
        <EmptyState
          icon={IconSearch}
          title={t('naoEncontrada.subtitulo')}
          description="O endereço pode estar incorreto — ou o registro existe, mas está fora do seu alcance de dados. Nesse caso o sistema responde “não encontrado” de propósito, para não confirmar a existência de um registro a quem não deveria vê-lo."
          action={
            <div className="flex flex-wrap items-center justify-center gap-3">
              <Link to="/" className="btn-primary">{t('naoEncontrada.voltar')}</Link>
              <HelpLink point="permissoes.nao-encontrado" />
            </div>
          }
        />
      </div>
    </>
  );
}
